/**
 * Reusable matching-puzzle helpers (drag items into category slots).
 */

/** @typedef {{ id: string, categoryId: string }} MatchItem */
/** @typedef {{ id: string }} MatchCategory */

/**
 * @param {Record<string, string|null|undefined>} placements itemId -> categoryId|null
 * @param {MatchItem[]} items
 * @returns {{ ok: boolean, wrongItemIds: string[], missingItemIds: string[], correctCount: number }}
 */
export function validateMatchingPlacements(placements, items) {
  const wrongItemIds = [];
  const missingItemIds = [];
  let correctCount = 0;

  items.forEach((item) => {
    const placed = placements[item.id];
    if (placed == null || placed === "") {
      missingItemIds.push(item.id);
      return;
    }
    if (placed === item.categoryId) {
      correctCount += 1;
    } else {
      wrongItemIds.push(item.id);
    }
  });

  return {
    ok: wrongItemIds.length === 0 && missingItemIds.length === 0,
    wrongItemIds,
    missingItemIds,
    correctCount,
  };
}

/**
 * Move an item into a category (one slot can hold many; item leaves previous slot).
 * @param {Record<string, string|null>} placements
 * @param {string} itemId
 * @param {string|null} categoryId
 */
export function placeItem(placements, itemId, categoryId) {
  return { ...placements, [itemId]: categoryId };
}

export function itemsInCategory(placements, categoryId) {
  return Object.entries(placements)
    .filter(([, cat]) => cat === categoryId)
    .map(([itemId]) => itemId);
}

export function unplacedItemIds(placements, items) {
  return items
    .filter((item) => placements[item.id] == null || placements[item.id] === "")
    .map((item) => item.id);
}
